module.exports = __webpack_public_path__ + "static/img/4.ab342461.png";